import React from 'react';

export const TableHeader: React.FC = () => {
  return (
    <thead>
      <tr className="border-b border-c-border bg-white">
        <th className="text-left py-3 px-4 text-xs font-medium text-gray-600 w-8"></th>
        <th className="text-left py-3 px-2 text-xs font-medium text-gray-600 w-8"></th>
        <th className="text-left py-3 px-2 text-xs font-medium text-gray-600 w-28">
          変動日
        </th>
        <th className="text-left py-3 px-2 text-xs font-medium text-gray-600">
          スコア
        </th>
        <th className="text-left py-3 px-2 text-xs font-medium text-gray-600">
          氏名/会社名
        </th>
        <th className="text-left py-3 px-2 text-xs font-medium text-gray-600 w-24">
          ステージ
        </th>
        <th className="text-left py-3 px-2 text-xs font-medium text-gray-600">
          フェーズ
        </th>
        <th className="text-left py-3 px-2 text-xs font-medium text-gray-600 w-26">
          最終コールアクション
        </th>
        <th className="text-left py-3 px-2 text-xs font-medium text-gray-600 w-24">
          担当者
        </th>
      </tr>
    </thead>
  );
};
